import { render, staticRenderFns } from "./PageProfileEdit.vue?vue&type=template&id=7b405f00&"
import script from "./PageProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./PageProfileEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports